import React, { useState } from 'react';
import Sections from '../Sections';
import classes from './body.module.css';
import cn from 'classnames';
import CheckDetails from '@components/Fireboard/components/Body/CheckDetails';
import { useOutletContext } from 'react-router-dom';
import Counters from '@components/Fireboard/components/Body/ChecksList/Counters';

const Body = props => {
  const {
    onFooterButtonPress,
    pendingCheckList,
    comingUpCheckList,
    inProgressCheckList,
    completeCheckList,
    seeCounterCheckList,
    selectedCheck,
    checksRowData,
    currentView,
    currency,
    supportsTipsOnTotalAmount,
    suppressTipsOnFireBoard,
    currentMode,
    filterByOrderTypes,
    setFilteredCheckListItem,
    setIsPickedUpCol,
    isPickedUpCol,
  } = props;

  const {
    updateOrderStatus,
    isFlip,
    setIsFlip,
    setIsExpanded,
    setTraceClick,
  } = useOutletContext();

  const [checksCount, setChecksCount] = useState();

  return (
    <div className={cn('col-12 row mx-0 pt-2 px-0 color-white fs_18 h-100')}>
      <div className={cn('col-8 px-0', classes.bodyContainer)}>
        <Sections
          {...props}
          pendingCheckList={pendingCheckList}
          comingUpCheckList={comingUpCheckList}
          inProgressCheckList={inProgressCheckList}
          completeCheckList={completeCheckList}
          seeCounterCheckList={seeCounterCheckList}
          // showPopup={showPopup}
          onFooterButtonPress={onFooterButtonPress}
        />
        <Counters
          checksCount={checksCount}
          checksRowData={checksRowData}
          setChecksCount={setChecksCount}
          currentMode={currentMode}
          filterByOrderTypes={filterByOrderTypes}
          setFilteredCheckListItem={setFilteredCheckListItem}
          setIsPickedUpCol={setIsPickedUpCol}
          isPickedUpCol={isPickedUpCol}
          currentView={currentView}
        />
      </div>

      <div
        className={cn('col-4  pr-0 text-white fw-400 ', classes.checkdetails)}
      >
        <CheckDetails
          selectedCheck={selectedCheck}
          checksRowData={checksRowData}
          currentView={currentView}
          currency={currency}
          supportsTipsOnTotalAmount={supportsTipsOnTotalAmount}
          suppressTipsOnFireBoard={suppressTipsOnFireBoard}
          setIsExpanded={setIsExpanded}
          setTraceClick={setTraceClick}
          selectedItem={selectedCheck}
          setIsFlip={setIsFlip}
          isFlip={isFlip}
          updateOrderStatus={updateOrderStatus}
          currentMode={currentMode}
        />
      </div>
    </div>
  );
};

export default Body;
